(function () {
  const root = document.querySelector('[data-aph-collection]');
  if (!root) return;

  const form = root.querySelector('[data-aph-collection-form]');
  const openBtn = root.querySelector('[data-aph-filter-open]');
  const closeBtn = root.querySelector('[data-aph-filter-close]');
  const backdrop = root.querySelector('[data-aph-filter-backdrop]');
  const gridBtns = root.querySelectorAll('[data-aph-grid-cols]');
  const searchInput = root.querySelector('[data-aph-collection-search]');
  const storageKey = 'aph-collection-cols';

  function setCols(cols) {
    root.dataset.cols = String(cols);
    gridBtns.forEach((btn) => {
      btn.classList.toggle('is-active', btn.dataset.aphGridCols === String(cols));
    });
    try {
      localStorage.setItem(storageKey, String(cols));
    } catch (_) {}
  }

  const savedCols = (() => {
    try {
      return localStorage.getItem(storageKey);
    } catch (_) {
      return null;
    }
  })();

  if (savedCols && ['3', '4', '5'].includes(savedCols)) {
    setCols(savedCols);
  } else if (root.dataset.cols) {
    setCols(root.dataset.cols);
  }

  gridBtns.forEach((btn) => {
    btn.addEventListener('click', () => setCols(btn.dataset.aphGridCols));
  });

  function openDrawer() {
    root.classList.add('is-drawer-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    root.classList.remove('is-drawer-open');
    document.body.style.overflow = '';
  }

  openBtn?.addEventListener('click', openDrawer);
  closeBtn?.addEventListener('click', closeDrawer);
  backdrop?.addEventListener('click', closeDrawer);

  if (form) {
    form.querySelectorAll('.aph-collection__filters-top input[type="checkbox"]').forEach((el) => {
      el.addEventListener('change', () => form.submit());
    });

    form.querySelectorAll('select[name="sort_by"]').forEach((el) => {
      el.addEventListener('change', () => form.submit());
    });

    form.querySelectorAll('input[type="radio"][name="limit"]').forEach((el) => {
      el.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('limit', el.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  if (searchInput && form) {
    searchInput.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      const query = searchInput.value.trim();
      if (!query) return;
      const url = new URL(window.location.href);
      url.searchParams.set('q', query);
      window.location.href = url.toString();
    });
  }

  root.querySelectorAll('[data-aph-wishlist]').forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      btn.classList.toggle('is-active');
    });
  });
})();
